import PAContactDetailsView from 'text!../views/pa-contact-details.html';
import PAPreQualQuestionsView from 'text!edge/quoteandbind/common/views/prequal-questions.html';
import DriverDetailsView from 'text!../views/pa-driver-details.html';
import VehicleDetailsView from 'text!../views/pa-vehicle-details.html';
import AdditionalInfoView from 'text!../views/pa-additional-info.html';
import PolicyInfoView from 'text!../views/pa-policy-info.html';
import PAContactDetailsCtrl from '../controllers/PAContactDetailsCtrl';
import PAPreQualQuestionsCtrl from '../controllers/PAPrequalQuestionsCtrl';
import DriverDetailsCtrl from '../controllers/PADriverDetailsCtrl';
import VehicleDetailsCtrl from '../controllers/PAVehicleDetailsCtrl';
import AdditionalInfoCtrl from '../controllers/PAAdditionalInfoCtrl';
import PolicyInfoCtrl from '../controllers/PAPolicyInfoCtrl';

export default () => {
    const wizardParentState = 'baseTransactionWizard';

    return {
        paContactDetails: {
            parent: wizardParentState,
            template: PAContactDetailsView,
            controller: PAContactDetailsCtrl,
            controllerAs: '$ctrl'
        },
        paPrequalQuestions: {
            parent: wizardParentState,
            controller: PAPreQualQuestionsCtrl,
            template: PAPreQualQuestionsView,
            controllerAs: '$ctrl'
        },
        paDriverDetails: {
            parent: wizardParentState,
            controller: DriverDetailsCtrl,
            template: DriverDetailsView
        },
        paVehicleDetails: {
            parent: wizardParentState,
            controller: VehicleDetailsCtrl,
            template: VehicleDetailsView
        },
        paAdditionalInfo: {
            parent: wizardParentState,
            controller: AdditionalInfoCtrl,
            template: AdditionalInfoView,
            controllerAs: '$ctrl'
        },
        paPolicyInfo: {
            parent: wizardParentState,
            controller: PolicyInfoCtrl,
            template: PolicyInfoView
        }
    };
};
